import { DateTime } from 'luxon';

import { Text, Flex } from '@vimeo/bokeh';
import { Calendar } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

type Props = {
  archivedTime: string;
  textColor: string;
};

export const ArchivedTimestamp = ({ archivedTime, textColor }: Props) => {
  const formattedTime = DateTime.fromISO(archivedTime).toFormat("MMMM d, yyyy 'at' h:mm a ZZZZ");

  return (
    <Flex justifyContent="start" alignItems="center" gap="sm">
      <Calendar w={24} h={24} color={textColor} />
      <Text variant={{ xs: 'heading-xs', md: 'heading-sm' }} color={textColor}>
        {translate({
          singular: 'Streamed on {formattedTime}',
          replacements: { formattedTime },
        })}
      </Text>
    </Flex>
  );
};
